export const css = {
    root: '_-jBGhRg',
    input: 'frgVdoCG',
    inputWrapper: 'cwLHBMoP',
    radioBackground: '_3rLADyhy',
    radioOuter: '_3hLS4DRB',
    radioInner: '_3mSsdE9D',
    focused: 'DxFcTlIf',
    checked: '_18CgnGma',
    disabled: '_3X0Bn5YZ',
    readonly: '_3JqASryv',
    invalid: '_11BYIUrt',
    valid: 'gwbouhFR',
    ' _key': 'afcpe-theme/afcpe/dojo/radio'
};
export default css;
